import React, { useMemo } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import UnityWebViewer from "../components/UnityWebViewer";
import { getAccessTokenCookie } from "../services/authToken";


const EmbedPage = () => {
  const { experienceId } = useParams();
  const [searchParams] = useSearchParams();

  const userData = useMemo(
    () => ({
      name: searchParams.get("userName"),
      id: searchParams.get("userId"),
      organizationId: searchParams.get("organizationId"),
      subscriptionStatus: searchParams.get("subscriptionStatus"),
      jwt: getAccessTokenCookie(),
    }),
    [searchParams],
  );

  return (
    <div className="App">
      <UnityWebViewer
        experienceId={experienceId}
        experienceRequestMode="teacher"
        userData={userData}
        embed
      />
    </div>
  );
};

export default EmbedPage;
